import React, { useState, useEffect, useRef } from 'react';
import JoditEditor from 'jodit-react';
import { toast } from 'react-toastify';
import { useMyContext } from '../../../components/Provider/CommonProvider';
import AdminCustomButton from '../../../components/CommonComponents/AdminCustomButton';
import { IoClose } from 'react-icons/io5';

const SubFooterMenuModal = ({ show, handleClose }) => {
    const editor = useRef(null);
    const [content, setContent] = useState('');
    const [loading, setLoading] = useState(false);
    const { fetchRequest } = useMyContext();
    const baseURL = process.env.REACT_APP_Baseurl;

    const fetchSubFooterMenu = async () => {
        try {
            const response = await fetchRequest({
                method: 'GET',
                url: `${baseURL}/admin/settings/sub-footer-menu`,
                params: {},
                data: {},
            });
            if (response?.status) {
                setContent(response.data || '');
            }
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        if (show) {
            fetchSubFooterMenu();
        }
    }, [show]);

    const handleUpdate = async () => {
        setLoading(true);
        try {
            const response = await fetchRequest({
                method: 'POST',
                url: `${baseURL}/admin/settings/sub-footer-menu`,
                params: {},
                data: { sub_footer_menu: content },
            });
            if (response?.status) {
                toast.success(response.message);
                handleClose();
            } else {
                toast.error(response.message);
            }
        } catch (error) {
            toast.error(error?.response?.data?.message || 'Error updating sub footer menu');
        } finally {
            setLoading(false);
        }
    };

    const config = React.useMemo(() => ({
        readonly: false,
        height: 400,
        theme: "default",
        toolbarSticky: false,
    }), []);

    return (
        <div className={`modal packageModel fade ${show ? 'd-block show' : ''}`} tabIndex="-1" role="dialog" aria-hidden="true">
            <div className="modal-dialog modal-lg theme-bg-color rounded-3" role="document">
                <div className="modal-content theme-bg-color">
                    <div className="modal-header theme-border-bottom-secondary">
                        <h5 className="modal-title theme-text-color">Sub Footer Menu</h5>
                        <button type="button" className="bg-transparent theme-text-color border-0" onClick={handleClose}>
                            <IoClose size={25} fill="currentColor" />
                        </button>
                    </div>
                    <div className="modal-body text-black">
                        <div className="text-black">
                            <JoditEditor
                                ref={editor}
                                value={content}
                                config={config}
                                onBlur={newContent => setContent(newContent)}
                            />
                        </div>
                    </div>
                    <div className="modal-footer border-0">
                        <button type="button" className="bg-transparent btn theme-text-color m-0 sliderBtnText" onClick={handleClose}>Close</button>
                        <AdminCustomButton saveMethod={handleUpdate} saveText="Update" loading={loading} className="m-0" />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SubFooterMenuModal;
